/**
 * @generated SignedSource<<2e4e9074c492991c1965d66d9843a26d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LessonsSidebar_facility$data = {
  readonly " $fragmentSpreads": FragmentRefs<"LessonsFiltersFragment_facility">;
  readonly " $fragmentType": "LessonsSidebar_facility";
};
export type LessonsSidebar_facility$key = {
  readonly " $data"?: LessonsSidebar_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"LessonsSidebar_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LessonsSidebar_facility",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LessonsFiltersFragment_facility"
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "0dc618cc45c26ba70eb5f447eed17ecf";

export default node;
